export const removeAmountSStorage = () => {
  sessionStorage.removeItem('amount');
};

export const removeAmountCommissionsSStorage = () => {
  sessionStorage.removeItem('commission');
};
